export enum StepStatus {
  NEXT = 0,
  NEW = 1,
  PROGRESS = 2,
  DONE = 3,
}